// extracted by mini-css-extract-plugin
export default {"clearSearchIcon":"searchField_clearSearchIcon__qlWbw","hideClearSearchIcon":"searchField_hideClearSearchIcon__zXRMa"};